/**
 * Ablage des Access-Tokens.
 *
 * Bewusst im Modulspeicher und NICHT in localStorage: ein dort abgelegtes
 * Token laesst sich per JavaScript auslesen, und ein einziges eingeschleustes
 * Skript reicht dann fuer eine uebernommene Sitzung. Im Modulspeicher ist es
 * beim Neuladen weg -- das ist kein Nachteil, sondern der Grund fuer das
 * httpOnly-Refresh-Cookie: der Kontext holt sich beim Start still ein neues
 * Access-Token.
 */
export interface Benutzer {
  id: number;
  email: string;
  vorname: string | null;
  nachname: string;
  titel: string | null;
  telefon: string | null;
  ist_plattform_admin: boolean;
}

export interface Mandant {
  id: number;
  firma_name: string;
  logo_url: string | null;
  primaerfarbe: string | null;
  status: string;
  /** `null`, solange der Ersteinrichtungs-Assistent noch nicht abgeschlossen (oder uebersprungen) wurde. */
  onboarding_abgeschlossen_am?: string | null;
}

export interface Sitzung {
  access_token: string;
  benutzer: Benutzer;
  mandant: Mandant;
  berechtigungen?: string[];
}

type Beobachter = (sitzung: Sitzung | null) => void;

let aktuelle: Sitzung | null = null;
const beobachter = new Set<Beobachter>();

function melden(): void {
  for (const b of beobachter) b(aktuelle);
}

export const authStore = {
  get sitzung(): Sitzung | null {
    return aktuelle;
  },

  get accessToken(): string | null {
    return aktuelle?.access_token ?? null;
  },

  setzen(sitzung: Sitzung): void {
    aktuelle = sitzung;
    melden();
  },

  /**
   * Ersetzt nur das Token, laesst Benutzer und Mandant stehen.
   *
   * Genau der Fall nach einer Erneuerung: dort kommt kein vollstaendiges
   * Profil zurueck, und den Benutzer dabei auf null zu setzen wuerde die
   * Oberflaeche mitten im Betrieb ausloggen.
   */
  tokenErneuern(token: string): void {
    if (!aktuelle) return;
    aktuelle = { ...aktuelle, access_token: token };
    melden();
  },

  leeren(): void {
    aktuelle = null;
    melden();
  },

  beobachten(fn: Beobachter): () => void {
    beobachter.add(fn);
    return () => beobachter.delete(fn);
  },
};
